/** First session seen by this page; kept on purpose when another tab re-logs in, so the server can detect stale tabs. */
let pinnedSessionId: string | null = null;

export function pinSessionId(sessionId: string): void {
  pinnedSessionId ??= sessionId;
}

export function getPinnedSessionId(): string | null {
  return pinnedSessionId;
}
